export const FormikToggle = ({ field, form }) => {
  const handleChange = () => {
    form.setFieldValue(field.name, !field.value);
  };
  return (
    <div>
      <button
        type="button"
        onClick={handleChange}
        className="border-2 border-primary px-5 py-2 rounded-full"
      >
        Tap to {!field.value ? "Show" : "Hide"}
      </button>
      <p>
        {" "}
        {!field.value
          ? "Now the testimony is hidden from the customers"
          : "Now the testimony is visible to the customers"}
      </p>
    </div>
  );
};
